<template>
    <div class="provider-forgot-password-page">
        <br/>
        <br/>
        <br/>
        <b-form @submit="onSubmitForgotPassword">
            <b-container>
                <b-row align-h="center">
                    <b-col cols="6">
                        <h2>Provider Forgot Password</h2>
                    </b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col cols="6">
                        <b-form-group id="forgot-password-username-group" label-for="forgot-password-username-input" label="Username:">
                            <b-form-input id="forgot-password-username-input" type="text" placeholder="Enter Username" v-model="form.username"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col cols="6">
                        <b-form-group id="forgot-password-verification-code-group" label-for="forgot-password-verification-code-input" label="Verification Code:">
                            <b-form-input id="forgot-password-verification-code-input" type="text" placeholder="Verification Code" v-model="form.verficationCode"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col cols="6">
                        <b-form-group id="forgot-password-password-group" label-for="forgot-password-password-input" label="Password:">
                            <b-form-input id="forgot-password-password-input" type="password" placeholder="Password" v-model="form.password"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col cols="6">
                        <b-form-group id="forgot-password-confirm-password-group" label-for="forgot-password-confirm-password-input" label="Confirm Password:">
                            <b-form-input id="forgot-password-confirm-password-input" type="password" placeholder="Confirm Password" v-model="form.confirmPassword"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col cols="6">
                        <b-button type="button" variant="secondary" @click="onSendVerificationCode">Send Verfication Code</b-button>
                        <b-button type="submit" variant="primary">Submit</b-button>
                    </b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col cols="6">
                        {{message}}
                    </b-col>
                </b-row>
            </b-container>
        </b-form>
    </div>
</template>
<script>
    import User from '../../user.js';

    export default
    {
        name: 'Provider-Forgot-Password',
        data ()
        {
            return {
                message: "",
                form:    {
                    username:           "",
                    verficationCode:    "",
                    password:           "",
                    confirmPassword:    ""
                }
            }
        },
        methods: {
            onSendVerificationCode,
            onSubmitForgotPassword
        }
    }


    ////////////////////////////////////////////////////////////////////////////////
    //
    //
    //
    function onSendVerificationCode( event )
    {
        var hasError    = false;
        if( this.form.username === undefined || this.form.username.length <= 0 )
        {
            this.message = "Please fill out the username\n";
            hasError     = true;
        }

        if( hasError )
            return;

        var _this = this;
        User.forgotPassword(
                this.form.username,
                User.UserEnum.PROVIDER,
                function successCallback()
                {
                    _this.message = "Please check the associated email for a confirmation number";
                },
                function failureCallback( error )
                {
                    _this.message = "An error occurred attempting to send a confirmation code";
                    hasError      = true;
                }
            );
    }


    ////////////////////////////////////////////////////////////////////////////////
    //
    //
    //
    function onSubmitForgotPassword( event )
    {
        var _this    = this;
        var hasError = false;
        if( this.form.password === undefined || this.form.password.length <= 0 )
        {
            this.message = "Please fill out the password\n";
            hasError     = true;
        }

        if( this.form.username === undefined || this.form.username.length <= 0 )
        {
            this.message = "Please fill out the username\n";
            hasError     = true;
        }

        if( this.form.verficationCode === undefined || this.form.verficationCode.length <= 0 )
        {
            this.message = "Please fill out the verification code\n";
            hasError     = true;
        }

        if( this.form.password !== this.form.confirmPassword )
        {
            this.message = "The passwords do not match.";
            hasError     = true;
        }

        if( hasError )
            return;

        User.confirmPassword(
                this.form.username,
                this.form.password,
                this.form.verficationCode,
                User.UserEnum.PROVIDER,
                function successCallback()
                {
                    _this.$router.push( '/account/signin' );
                },
                function failureCallback( error )
                {
                    _this.message = "An error occurred attempting to update the provider password.";
                }
            );
    }
</script>


// WEBPACK FOOTER //
// src/components/provider/provider-forgot-password.vue